import React from 'react';
import AsyncCreateDashboardGadgetModal, {
	type FilterIdOrJql,
} from '@atlassian/jira-dashboard-create-dashboard-gadget-modal';

import { useRouterActions } from '@atlassian/jira-router';
import type { ModalProps } from '../../types';

export type CreateDashboardGadgetModalOptions = FilterIdOrJql;

export type Props = CreateDashboardGadgetModalOptions & ModalProps;

const CreateDashboardGadgetModal = ({
	onClose,
	baseUrl: _,
	onInitiateFailed: __,
	onInitiateSuccess: ___,
	...filterIdOrJql
}: Props) => {
	const { push } = useRouterActions();

	const onSuccess = (dashboardId: string) => {
		onClose();
		push(`/jira/dashboards/${dashboardId}/edit`);
	};

	return (
		<AsyncCreateDashboardGadgetModal onSuccess={onSuccess} onCancel={onClose} {...filterIdOrJql} />
	);
};

export default CreateDashboardGadgetModal;
